import { dailySessionNotes } from '../../actions/constant';

const {
  GET_PATIENT_INFO_DAILY_SESSION_FAILURE,
  GET_PATIENT_INFO_DAILY_SESSION_SUCCESS,
  GET_PATIENT_INFO_DAILY_SESSION_LOADING,
} = dailySessionNotes;

const intitialstate: object = {
  response: null,
  isError: false,
  errorMessage: '',
  loading: false,
};

export const getDailySessionPatientInfo = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_PATIENT_INFO_DAILY_SESSION_SUCCESS: {
      return {
        ...state,
        isError: false,
        response: action.payload?.data,
        loading: false,
      };
    }

    case GET_PATIENT_INFO_DAILY_SESSION_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };
    case GET_PATIENT_INFO_DAILY_SESSION_LOADING:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
